import { createSelector } from 'reselect';
import property from 'lodash/property';

import getQueryBuilderState from './getQueryBuilderState';

export default createSelector(
  getQueryBuilderState,
  property('entities.center'),
);
